<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_24276_7568)">
      <path
        d="M26.0019 12.6949C26.3861 11.8057 26.7836 10.9191 27.1987 10.0387C27.8349 8.73528 26.9149 7.38164 25.0889 7.1622C21.3813 6.72596 17.635 6.72596 13.9283 7.1622C12.1014 7.38164 11.1823 8.73528 11.8177 10.0387C12.2328 10.9191 12.6302 11.8048 13.0145 12.6949C9.232 14.9227 6.69479 19.0348 6.69479 23.7417C6.69479 30.8175 12.431 33.6535 19.5077 33.6535C26.5844 33.6535 32.3207 30.8184 32.3207 23.7417C32.3207 19.0357 29.7826 14.9227 26.0019 12.6958V12.6949Z"
        fill="#B6E5C3"
      />
      <g opacity="0.8">
        <path
          d="M16.9879 28.7253H16.9729C16.5816 28.7253 16.2414 28.505 16.1374 28.1269L14.0373 20.4651C13.9087 19.9954 14.1854 19.5239 14.6551 19.3952C15.1248 19.2666 15.6095 19.5503 15.7373 20.0192L17.0407 24.7939L18.5759 19.8359C18.6905 19.4675 19.0315 19.2057 19.4175 19.2057H19.5277C19.9269 19.2057 20.2759 19.4851 20.379 19.8702L21.7001 24.8045L23.2194 20.0359C23.3674 19.5724 23.8636 19.3177 24.3263 19.4648C24.7898 19.6129 25.0463 20.1091 24.8991 20.5726L22.4677 28.2107C22.3487 28.5834 22.0032 28.8329 21.6075 28.8249C21.2162 28.8161 20.8778 28.55 20.7765 28.1719L19.4149 23.0922L17.8286 28.1543C17.714 28.5235 17.3721 28.7236 16.987 28.7236L16.9879 28.7253Z"
          fill="#56CB77"
        />
        <path
          d="M25.6788 22.5567H13.1646C12.6782 22.5567 12.2834 22.1619 12.2834 21.6754C12.2834 21.1889 12.6782 20.7941 13.1646 20.7941H25.6788C26.1653 20.7941 26.5601 21.1889 26.5601 21.6754C26.5601 22.1619 26.1653 22.5567 25.6788 22.5567Z"
          fill="#56CB77"
        />
      </g>
      <path
        d="M19.1256 14.4276C14.81 14.4276 12.4526 13.3366 12.3116 13.2705C11.8727 13.0608 11.6859 12.5346 11.8956 12.0958C12.1045 11.6578 12.6288 11.4709 13.0677 11.678C13.1356 11.7089 17.6874 13.7561 25.7995 11.8367C26.2728 11.7256 26.7478 12.0173 26.8597 12.4914C26.9717 12.9647 26.6791 13.4397 26.2049 13.5516C23.4562 14.202 21.0873 14.4276 19.1247 14.4276H19.1256Z"
        fill="#56CB77"
      />
    </g>
    <circle
      cx="30.0534"
      cy="29.0755"
      r="5.9466"
      fill="#56CB77"
    />
    <path
      d="M27.5 28.9483L29.3571 31L32.5 27.5"
      stroke="white"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <clipPath id="clip0_24276_7568">
        <rect
          width="25.625"
          height="26.8173"
          fill="white"
          transform="translate(6.69479 6.83502)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
